<p>
  {{ 'cookies.description' | translate }}
  <a routerLink="/cookie-policy" target="_blank" rel="noopener">
    {{ 'cookies.policy' | translate | lowercase }}
    <opac-icon icon="external_link"></opac-icon>
  </a>
</p>
